import LocalCache from "src/shared/LocalCache";

/**
 * This class is responsible for reaching the Vibes Eligibility Service
 * to determine eligibility for targeting
 */
export default class EligibilityService {
    private readonly host: string;
    private readonly cache: LocalCache;

    constructor(host: string, cache: LocalCache) {
        this.host = host;
        this.cache = cache;
    }

    async isEligible(): Promise<boolean> {
        const cache = this.cache.get('vibes-cache:eligibility');

        if (cache) {
           return cache === 'true';
        }

        const res = await fetch(`${this.host}/gp/vibes/api/eligibility`, {
            redirect: "error",
            headers: {
              'Accept': "application/json",
              'X-Requested-With': 'XMLHttpRequest', // MONS marks requests with this header as AJAX requests and handles things differently, like authentication errors
            }
        });

        if (!res.ok) {
            return false;
        }

        let body: { can_target: boolean; ttl: number };
        try {
            body = await res.json();
        } catch (e) {
            throw new Error(`Could not parse eligibility response body, status code: ${res.status}`);
        }

        if (!('can_target' in body) || !('ttl' in body)) {
            throw new Error("Vibes eligibility response missing can_target or ttl information");
        }

        const canTargetStr = body.can_target ? 'true' : 'false';

        // Only cache if we can't target
        if (!body.can_target) {
            this.cache.set('vibes-cache:eligibility', canTargetStr, body.ttl);
        }

        return body.can_target;
    }
}